import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import TrustBadge from './TrustBadge';

// 사용자 신뢰도 상세 — 풀 오버레이 모달
// 병렬 fetch: trust-score + users/:id/reviews
function TrustScoreDetail(props){
  var userId=props.userId;
  var onClose=props.onClose;

  var[trust,setTrust]=useState(null);
  var[reviews,setReviews]=useState([]);
  var[summary,setSummary]=useState(null);
  var[loading,setLoading]=useState(true);
  var[error,setError]=useState('');

  useEffect(function(){
    if(!userId)return;
    setLoading(true);
    setError('');
    Promise.all([
      authFetch(API+'/auctions/users/'+userId+'/trust-score').then(function(r){return r.json()}),
      authFetch(API+'/auctions/users/'+userId+'/reviews').then(function(r){return r.json()})
    ]).then(function(results){
      var t=results[0];
      var rv=results[1];
      if(t&&t.success&&t.data){
        setTrust(t.data);
      }else{
        setError((t&&t.error)||'신뢰도 조회 실패');
      }
      if(rv&&rv.success&&rv.data){
        setReviews(rv.data.reviews||[]);
        setSummary(rv.data.summary||null);
      }
    }).catch(function(){setError('서버 연결 실패')}).then(function(){setLoading(false)});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[userId]);

  // 다음 레벨 계산 (trustCalculator.js 로직 참조)
  var nextLevelInfo=function(level,totalDeals,avgScore){
    if(level==='warning')return {next:null,msg:'신뢰도 경고 상태',needDeals:0,needScore:0};
    if(level==='newbie')return {next:'bronze',msg:'브론즈까지',needDeals:Math.max(0,3-totalDeals),needScore:0};
    if(level==='bronze')return {next:'silver',msg:'실버까지',needDeals:Math.max(0,10-totalDeals),needScore:avgScore<3.5?3.5:0};
    if(level==='silver')return {next:'gold',msg:'골드까지',needDeals:Math.max(0,30-totalDeals),needScore:avgScore<4.0?4.0:0};
    if(level==='gold')return {next:'diamond',msg:'다이아까지',needDeals:Math.max(0,50-totalDeals),needScore:avgScore<4.5?4.5:0};
    return {next:null,msg:'최고 레벨 달성',needDeals:0,needScore:0};
  };

  var starRow=function(score){
    var full=Math.floor(score);
    var s='';
    for(var i=0;i<5;i++)s+=(i<full?'★':'☆');
    return s;
  };

  return (
    <div onClick={onClose}
      style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9998,padding:16}}>
      <div onClick={function(e){e.stopPropagation()}}
        style={{background:'#fff',borderRadius:16,width:'100%',maxWidth:480,maxHeight:'90vh',overflowY:'auto',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>

        {/* 헤더 */}
        <div style={{padding:'16px 20px',borderBottom:'1px solid #e5e7eb',display:'flex',alignItems:'center',justifyContent:'space-between',position:'sticky',top:0,background:'#fff',zIndex:1}}>
          <div style={{fontSize:16,fontWeight:800,color:'#1B3A5C',display:'flex',alignItems:'center',gap:6}}>
            <span>🛡</span><span>신뢰도 상세</span>
          </div>
          <button onClick={onClose}
            style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'#94a3b8',padding:4}}>✕</button>
        </div>

        {/* 본문 */}
        <div style={{padding:'20px'}}>
          {loading&&(
            <div style={{padding:40,textAlign:'center',color:'#94a3b8',fontSize:13}}>불러오는 중...</div>
          )}

          {error&&!loading&&(
            <div style={{padding:'10px 12px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:8,fontSize:12,color:'#dc2626',marginBottom:12}}>
              ⚠ {error}
            </div>
          )}

          {!loading&&trust&&(function(){
            var stats=trust.stats||{};
            var totalDeals=(stats.totalSells||0)+(stats.totalBuys||0);
            var avgScore=summary&&summary.avgScore?summary.avgScore:Math.max(stats.avgScoreAsSeller||0,stats.avgScoreAsBuyer||0);
            var next=nextLevelInfo(trust.trustLevel,totalDeals,avgScore);
            return (
              <div>
                {/* 신뢰도 레벨 헤더 */}
                <div style={{padding:'20px',background:'linear-gradient(135deg,#f8fafc 0%,#e2e8f0 100%)',borderRadius:12,textAlign:'center',marginBottom:16}}>
                  <div style={{fontSize:56,marginBottom:6}}>{trust.trustBadge&&trust.trustBadge.icon}</div>
                  <div style={{fontSize:20,fontWeight:800,color:trust.trustBadge&&trust.trustBadge.color}}>{trust.trustBadge&&trust.trustBadge.label}</div>
                  {next.next&&(
                    <div style={{fontSize:11,color:'#64748b',marginTop:8}}>
                      {next.msg} {next.needDeals>0&&<span>거래 <strong>{next.needDeals}건</strong></span>}
                      {next.needDeals>0&&next.needScore>0&&' · '}
                      {next.needScore>0&&<span>평점 <strong>{next.needScore}</strong>이상</span>}
                      {next.needDeals===0&&next.needScore===0&&<span>조건 충족</span>}
                    </div>
                  )}
                </div>

                {/* 통계 */}
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:16}}>
                  <div style={{padding:'12px',background:'#f8fafc',borderRadius:8,textAlign:'center'}}>
                    <div style={{fontSize:10,color:'#94a3b8'}}>총 거래</div>
                    <div style={{fontSize:18,fontWeight:800,color:'#1B3A5C',marginTop:4}}>{totalDeals}<span style={{fontSize:11,marginLeft:2,fontWeight:700}}>건</span></div>
                    <div style={{fontSize:9,color:'#94a3b8',marginTop:2}}>판매 {stats.totalSells||0} · 구매 {stats.totalBuys||0}</div>
                  </div>
                  <div style={{padding:'12px',background:'#f8fafc',borderRadius:8,textAlign:'center'}}>
                    <div style={{fontSize:10,color:'#94a3b8'}}>평균 평점</div>
                    <div style={{fontSize:18,fontWeight:800,color:'#F59E0B',marginTop:4}}>{avgScore>0?avgScore.toFixed(1):'—'}</div>
                    <div style={{fontSize:13,color:'#F59E0B',marginTop:2,letterSpacing:1}}>{avgScore>0?starRow(avgScore):''}</div>
                  </div>
                </div>

                {/* 경고 지표 */}
                {(stats.cancelledCount>0||stats.selectionTimeoutCount>0)&&(
                  <div style={{padding:'10px 12px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:8,marginBottom:16,fontSize:11,color:'#9a3412'}}>
                    {stats.cancelledCount>0&&<div>⚠ 경매 취소 {stats.cancelledCount}회</div>}
                    {stats.selectionTimeoutCount>0&&<div>⚠ 낙찰자 선택 만료 {stats.selectionTimeoutCount}회</div>}
                  </div>
                )}

                {/* 최근 후기 */}
                <div style={{marginBottom:14}}>
                  <div style={{fontSize:11,fontWeight:700,color:'#64748b',marginBottom:8}}>최근 받은 후기 {summary&&'('+summary.totalReviews+')'}</div>
                  {reviews.length===0?(
                    <div style={{padding:16,textAlign:'center',background:'#f8fafc',borderRadius:8,fontSize:11,color:'#94a3b8'}}>
                      아직 받은 후기가 없습니다
                    </div>
                  ):(
                    <div style={{display:'flex',flexDirection:'column',gap:6}}>
                      {reviews.slice(0,5).map(function(r,i){
                        return (
                          <div key={i} style={{padding:'10px 12px',background:'#f8fafc',borderRadius:6}}>
                            <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:4}}>
                              <span style={{fontSize:13,color:'#F59E0B',letterSpacing:1}}>{starRow(r.score)}</span>
                              <span style={{fontSize:10,color:'#64748b'}}>{r.role==='seller'?'출품자로서':'낙찰자로서'}</span>
                              <span style={{fontSize:10,color:'#94a3b8',marginLeft:'auto'}}>{r.carModel||''}</span>
                            </div>
                            {r.comment&&(
                              <div style={{fontSize:11,color:'#475569',lineHeight:1.5}}>{r.comment}</div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                {/* 레벨 가이드 */}
                <div style={{padding:'12px',background:'#f8fafc',borderRadius:8,fontSize:10,color:'#64748b',lineHeight:1.7}}>
                  <div style={{fontWeight:700,color:'#475569',marginBottom:6}}>레벨 기준</div>
                  <div>🌱 새내기 → 🥉 브론즈 <span style={{color:'#94a3b8'}}>(거래 3건+)</span></div>
                  <div>🥉 브론즈 → 🥈 실버 <span style={{color:'#94a3b8'}}>(10건+, 평점 3.5+)</span></div>
                  <div>🥈 실버 → 🥇 골드 <span style={{color:'#94a3b8'}}>(30건+, 평점 4.0+)</span></div>
                  <div>🥇 골드 → 💎 다이아 <span style={{color:'#94a3b8'}}>(50건+, 평점 4.5+)</span></div>
                </div>
              </div>
            );
          })()}
        </div>
      </div>
    </div>
  );
}

export default TrustScoreDetail;
